import styled from 'styled-components';
import { ButtonTag } from '../Button/styles';

export const ReviewSection = styled.section`
  margin-bottom: 35px;
  padding: 0 10px;
  
  @media(min-width: 768px) {
    padding: 0 40px;
  }
  
  @media(min-width: 1024px) {
    padding: 0;
  }
`;


export const ReviewsHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  @media(min-width: 768px) {
    margin-bottom: -5px;
  }
`;

export const ReviewHeading = styled.h2`
  margin: 0;
  padding: 0;
  
  font-size: 18px;
  line-height: 1;
  
  @media(min-width: 768px) {
    font-size: 24px;
  }
`;

export const ReviewsButtonContainer = styled.div`
  padding: 0 15px;
`;

export const ReviewButton = styled(ButtonTag)`
  width: 100%;
  
  @media(min-width: 768px) {
    width: auto;
    padding: 20px 35px;
  }
`;

export const ReviewsListWrapper = styled.div`
`;

export const ReviewsList = styled.div`
  margin-bottom: 15px;
  
  @media(min-width: 768px) {
    margin: 0 -20px;
    margin-bottom: 0;
  }
`;

export const ReviewsItem = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.lightGray};
`;
